import { useState } from 'react'
import { redirect, useLoaderData, useNavigate } from 'react-router'
import { Flex } from '@radix-ui/themes'
import { PageHeading } from '@/components/subscription/page-heading'
import { Button } from '~/components/subscription/button'
import { TextLink } from '@/components/subscription/text-link'
import { formatTime } from '@/lib/shipment'
import { createClient, JSONAPIResponse } from '@/api-client'
import { Subscriptions } from '@/api-client/Subscriptions'
import { Subscription } from '~/api-client/data-contracts'
import { styles } from './styles.css'

export const loader = async () => {
  const subscriptions = await fetchSubscriptions()
  const subscription = subscriptions.data.data[0] as unknown as Subscription

  if (!subscription) {
    return redirect('/subscription/mypage')
  } else {
    return subscriptions
  }
}

function fetchSubscriptions() {
  return createClient(Subscriptions).getSubscriptions()
}

export const SubscriptionMypageCancel: React.FC = () => {
  const {
    data: { data: subscriptions },
  } = useLoaderData() as JSONAPIResponse<typeof fetchSubscriptions>
  const [errorMessage, setErrorMessage] = useState('')

  const navigate = useNavigate()
  const subscription = subscriptions[0]
  const [checked, setChecked] = useState(false)

  const handleClickCancel: React.MouseEventHandler<HTMLButtonElement> = async () => {
    try {
      await createClient(Subscriptions).postSubscriptionsIdCancel(subscription.id)
      navigate('/subscription/mypage', { state: { message: '定期便を解約しました。' } })
    } catch (error) {
      setErrorMessage(error.response.data.error.message_displayable)
    }
  }

  return (
    <Flex direction="column" align="center" gap="40px">
      <Flex direction="column" align="center" gap="32px" width="100%">
        <PageHeading>定期便解約のお手続き</PageHeading>
        <p className={styles.warn}>
          {formatTime(1000 * subscription.attributes.skip_deadline)}までのお手続きで、
          <br />
          次回発送分から定期便を停止できます
        </p>
      </Flex>
      <Flex direction="column" align="start" gap="8px" width="100%">
        <h3 className={styles.heading}>必ずお読みください</h3>
        <ul className={styles.list}>
          <li>上記の期限を過ぎてしまった場合は、次回のお届けをキャンセルできません。</li>
          <li>次回分のみお休み（スキップ）することも可能です。その場合はこちらからお手続きいただけます。</li>
        </ul>
      </Flex>
      <label className={styles.checkbox}>
        <Flex direction="row" align="center" gap="4px">
          <input type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)} />
          <span>上記を確認しました</span>
        </Flex>
      </label>
      <Flex direction="column" align="center" gap="32px" width="100%">
        <Flex direction="column" align="center" gap="16px" width="100%">
          {!!errorMessage && <p>{errorMessage}</p>}
          <Button as="button" size="m" fluid disabled={!checked} onClick={handleClickCancel}>
            定期便を解約する
          </Button>
        </Flex>
        <TextLink to="/subscription/mypage">マイページに戻る</TextLink>
      </Flex>
    </Flex>
  )
}
